import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, Mail, ExternalLink } from 'lucide-react';

const SHOP_URL = 'https://shop.paramountpeptides.com/MARKBECKER';

const EXTERNAL_LINKS = [
  { href: 'https://peptidesforcancer.org', label: 'Peptides for Cancer' },
  { href: 'https://peptidesforfertility.org', label: 'Peptides for Fertility' },
  { href: 'https://peptidesdictionary.com', label: 'Peptides Dictionary' },
  { href: 'https://peptidesforweightloss.org', label: 'Peptides for Weight Loss' },
  { href: 'https://peptidesforworkouts.com', label: 'Peptides for Workouts' },
  { href: 'https://peptidesskincare.net', label: 'Peptides Skincare' },
  { href: 'https://peptidesforantiaging.com', label: 'Peptides for Anti-Aging' },
];

const ExternalLinkItem = ({ href, label }) => (
  <li>
    <a href={href} target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors inline-flex items-center gap-1">
      {label}
      <ExternalLink size={12} />
    </a>
  </li>
);

const FooterBrand = () => (
  <div>
    <div className="flex items-center gap-2 font-bold text-xl text-white mb-4">
      <FlaskConical className="text-blue-400" size={28} />
      <span>PeptideSciences<span className="text-blue-400">.ai</span></span>
    </div>
    <p className="text-sm text-gray-400">World's leading resource for peptide research and education.</p>
  </div>
);

const FooterResearch = () => (
  <div>
    <h3 className="font-bold text-white mb-4">Research</h3>
    <ul className="space-y-2 text-sm">
      <li><Link to="/research" className="hover:text-blue-400 transition-colors">All Articles</Link></li>
      <li><Link to="/research/weight-loss" className="hover:text-blue-400 transition-colors">Weight Loss</Link></li>
      <li><Link to="/research/anti-aging" className="hover:text-blue-400 transition-colors">Anti-Aging</Link></li>
      <li><Link to="/research/fitness" className="hover:text-blue-400 transition-colors">Fitness</Link></li>
    </ul>
  </div>
);

const FooterTopics = () => (
  <div>
    <h3 className="font-bold text-white mb-4">Popular Topics</h3>
    <ul className="space-y-2 text-sm">
      <li><Link to="/research/glp" className="hover:text-blue-400 transition-colors">GLP-1 Agonists</Link></li>
      <li><Link to="/research/growth-hormone" className="hover:text-blue-400 transition-colors">Growth Hormone</Link></li>
      <li><Link to="/research/brain-health" className="hover:text-blue-400 transition-colors">Brain Health</Link></li>
      <li><Link to="/research/recovery" className="hover:text-blue-400 transition-colors">Recovery</Link></li>
    </ul>
  </div>
);

const FooterUsefulLinks = () => (
  <div>
    <h3 className="font-bold text-white mb-4">Useful Links</h3>
    <ul className="space-y-2 text-sm">
      {EXTERNAL_LINKS.map(link => <ExternalLinkItem key={link.href} {...link} />)}
    </ul>
  </div>
);

const FooterShop = () => (
  <div>
    <h3 className="font-bold text-white mb-4">Shop & Contact</h3>
    <ul className="space-y-2 text-sm">
      <li>
        <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors inline-flex items-center gap-1">
          Shop Peptides <ExternalLink size={14} />
        </a>
      </li>
      <li className="flex items-center gap-1">
        <Mail size={14} />
        <span>info@peptidesciences.ai</span>
      </li>
    </ul>
  </div>
);

const FooterDisclaimer = () => (
  <div className="border-t border-gray-800 mt-12 pt-8">
    <div className="bg-yellow-900/20 border border-yellow-700/30 rounded-lg p-6 mb-8">
      <h4 className="font-bold text-yellow-500 mb-3 text-lg">IMPORTANT DISCLAIMER</h4>
      <p className="text-sm text-gray-300 leading-relaxed">
        <strong className="text-white">ALL ARTICLES AND PRODUCT INFORMATION PROVIDED ON THIS WEBSITE ARE FOR INFORMATIONAL AND EDUCATIONAL PURPOSES ONLY.</strong> The products offered are intended for laboratory research use only, specifically in vitro studies—experiments conducted outside of living organisms (Latin: in glass). These products are not medicines or drugs and have not been approved by the FDA to prevent, treat, cure, or prevent any medical condition, ailment, or disease. They are not for human or animal consumption. <strong className="text-white">Bodily introduction of any kind into humans or animals is strictly forbidden by law.</strong>
      </p>
    </div>
  </div>
);

const Footer = () => (
  <footer className="bg-gray-900 text-gray-300">
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="grid md:grid-cols-5 gap-8">
        <FooterBrand />
        <FooterResearch />
        <FooterTopics />
        <FooterUsefulLinks />
        <FooterShop />
      </div>
      <FooterDisclaimer />
      <div className="text-sm text-center text-gray-400">
        <p>&copy; {new Date().getFullYear()} PeptideSciences.ai - All rights reserved.</p>
        <p className="mt-2">Educational content for informational purposes only. Consult healthcare professionals before starting any peptide therapy.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
